import React from 'react';
import MobileBannerCarousel from '../MobileBannerCarousel/MobileBannerCarousel';
import { BANNER_LOCATIONS } from '../../../modules/Banners/bannersConstants';
import useBannersList from '../../../modules/Banners/hooks/useBannersList';

interface IMobilePortfolioBannerCarouselProps {
    className?: string;
}

function MobilePortfolioBannerCarousel(props: IMobilePortfolioBannerCarouselProps) {
    const { className } = props;
    const bannersList = useBannersList({ location: BANNER_LOCATIONS.PORTFOLIO, short: true });

    return <MobileBannerCarousel className={className}>
        {bannersList}
    </MobileBannerCarousel>;
}

export default MobilePortfolioBannerCarousel;
